import { storeService } from ".";

const REMEMBER_EMAIL_KEY = "remember-email";

export const get = () => storeService.get(REMEMBER_EMAIL_KEY);
export const remove = () => storeService.remove(REMEMBER_EMAIL_KEY);
export const set = (value) => storeService.set(REMEMBER_EMAIL_KEY, value);
